export function getLocationDisplayText(location: uui.domain.client.Location): string {
  return location.address
}
